/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Delete_Dialog_Confirm_SuffixInputs */

const vi_customer_delete_dialog_confirm_suffix = /** @type {(inputs: Customer_Delete_Dialog_Confirm_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Bạn có chắc chắn?`)
};

/**

* @param {Customer_Delete_Dialog_Confirm_SuffixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_delete_dialog_confirm_suffix = /** @type {((inputs?: Customer_Delete_Dialog_Confirm_SuffixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Delete_Dialog_Confirm_SuffixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_delete_dialog_confirm_suffix(inputs)
});